import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath } from '../config/Constant';
import DeviceInfo from 'react-native-device-info';


export const fetchWhoAmI = () => {
    return async (_dispatch, getState) => {

        let GuestJourneySessionToken = await AsyncStorage.getItem("sessionToken");
        const deviceName = await DeviceInfo.getDeviceName();

        try {
            const response = await clientConfigPath.post(`/whoAmI/fetch`, {
                header: {
                    deviceName: deviceName,
                },
                payload: {},
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Cookie': `JSESSIONID=${GuestJourneySessionToken}`,
                },
            });

            const data = response?.data;
            return {status: "SUCCESS", data: data.payload};
        } catch (error) {
            console.error('fetchWhoAmI error:', error);
            return {status: "ERROR"};
        }
    }
};